import { render, staticRenderFns } from "./ManagerContractsForm.vue?vue&type=template&id=2c9d4666"
import script from "./ManagerContractsForm.vue?vue&type=script&lang=js"
export * from "./ManagerContractsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports